import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Modal,
    Stack,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

import { useFillPathway } from '../../../../contexts/fill/use-fill-prescription';

export type PriorAuthSelfPayModalProps = {
    isOpen: boolean;
    close: () => void;
};

export const PriorAuthSelfPayModal: FC<PriorAuthSelfPayModalProps> = ({
    isOpen,
    close,
}) => {
    const { t } = useTranslation('lilly');
    const { setPathway } = useFillPathway();

    return (
        <Modal
            opened={isOpen}
            onClose={close}
            title={t('fill.insurance.pathSelect.selfPayModal.title')}
        >
            <Stack gap="lg">
                <Subtitle2>
                    {t('fill.insurance.pathSelect.selfPayModal.heading')}
                </Subtitle2>
                <Body1>
                    {t('fill.insurance.pathSelect.selfPayModal.line1')}
                </Body1>
                <Body1>
                    {t('fill.insurance.pathSelect.selfPayModal.line2')}
                </Body1>
                <Stack gap="xs">
                    <Button
                        variant="filled"
                        onClick={() => setPathway({ pathway: 'self-pay' })}
                        size="lg"
                    >
                        {t(
                            'fill.insurance.pathSelect.selfPayModal.continueBtn'
                        )}
                    </Button>
                    <Button variant="outline" onClick={close} size="lg">
                        {t('fill.insurance.pathSelect.selfPayModal.closeBtn')}
                    </Button>
                </Stack>
            </Stack>
        </Modal>
    );
};
